import { ProductAvailability } from "~/types/product";

export const fetchProductAvailability = async (
  styleCode: string,
  color: string,
): Promise<ProductAvailability | null> => {
  try {
    const request = await fetch(
      `/resources/product-availability?style_code=${styleCode}&color=${color}`,
    );

    if (!request.ok) throw new Error("Failed to fetch product availability");

    const response = (await request.json()) as ProductAvailability | null;

    return response;
  } catch (error) {
    return null;
  }
};
